export default __webpack_public_path__ + "static/media/GuideLogin.079be874.png";